import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { Component } from '@wordpress/element';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import classnames from 'classnames';
/**
 * Internal dependencies
 */

import SelectControl from '../select-control';
import { countries, coupons, customers, downloadIps, emails, orders, product, productCategory, taxes, usernames, variations } from './autocompleters';
/**
 * A search box which autocompletes results while typing, allowing for the user to select an existing object
 * (product, order, customer, etc). Currently only products are supported.
 */

var Search =
/*#__PURE__*/
function (_Component) {
  _inherits(Search, _Component);

  function Search(props) {
    var _this;

    _classCallCheck(this, Search);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Search).call(this, props));
    _this.state = {
      options: []
    };
    _this.appendFreeTextSearch = _this.appendFreeTextSearch.bind(_assertThisInitialized(_this));
    _this.fetchOptions = _this.fetchOptions.bind(_assertThisInitialized(_this));
    _this.updateSelected = _this.updateSelected.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Search, [{
    key: "getAutocompleter",
    value: function getAutocompleter() {
      switch (this.props.type) {
        case 'categories':
          return productCategory;

        case 'countries':
          return countries;

        case 'coupons':
          return coupons;

        case 'customers':
          return customers;

        case 'downloadIps':
          return downloadIps;

        case 'emails':
          return emails;

        case 'orders':
          return orders;

        case 'products':
          return product;

        case 'taxes':
          return taxes;

        case 'usernames':
          return usernames;

        case 'variations':
          return variations;

        default:
          return {};
      }
    }
  }, {
    key: "getFormattedOptions",
    value: function getFormattedOptions(options, query) {
      var autocompleter = this.getAutocompleter();
      var formattedOptions = [];
      options.forEach(function (option) {
        var formattedOption = {
          key: autocompleter.getOptionIdentifier(option),
          label: autocompleter.getOptionLabel(option, query),
          keywords: autocompleter.getOptionKeywords(option).filter(Boolean),
          value: option
        };
        formattedOptions.push(formattedOption);
      });
      return formattedOptions;
    }
  }, {
    key: "fetchOptions",
    value: function fetchOptions(previousOptions, query) {
      var _this2 = this;

      var autocompleter = this.getAutocompleter();
      return autocompleter.options(query).then(
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(response) {
          var options;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  options = _this2.getFormattedOptions(response, query);

                  _this2.setState({
                    options: options
                  });

                  return _context.abrupt("return", options);

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "updateSelected",
    value: function updateSelected(selected) {
      var onChange = this.props.onChange;
      var autocompleter = this.getAutocompleter();
      var formattedSelections = selected.map(function (option) {
        return option.value ? autocompleter.getOptionCompletion(option.value) : option;
      });
      onChange(formattedSelections);
    }
  }, {
    key: "appendFreeTextSearch",
    value: function appendFreeTextSearch(options, query) {
      var autocompleter = this.getAutocompleter();
      var allowFreeTextSearch = this.props.allowFreeTextSearch;

      if (!allowFreeTextSearch) {
        return options;
      }

      return [].concat(_toConsumableArray(autocompleter.getFreeTextOptions(query)), _toConsumableArray(options));
    }
  }, {
    key: "render",
    value: function render() {
      var autocompleter = this.getAutocompleter();
      var _this$props = this.props,
          className = _this$props.className,
          inlineTags = _this$props.inlineTags,
          placeholder = _this$props.placeholder,
          selected = _this$props.selected,
          showClearButton = _this$props.showClearButton,
          staticResults = _this$props.staticResults,
          disabled = _this$props.disabled;
      var options = this.state.options;
      var inputType = autocompleter.inputType ? autocompleter.inputType : 'text';
      return createElement("div", null, createElement(SelectControl, {
        className: classnames('woocommerce-search', className, {
          'is-static-results': staticResults
        }),
        disabled: disabled,
        hideBeforeSearch: true,
        inlineTags: inlineTags,
        isSearchable: true,
        label: placeholder,
        getSearchExpression: autocompleter.getSearchExpression,
        multiple: true,
        placeholder: placeholder,
        onChange: this.updateSelected,
        onFilter: this.appendFreeTextSearch,
        onSearch: this.fetchOptions,
        options: options,
        searchInputType: inputType,
        selected: selected,
        showClearButton: showClearButton
      }));
    }
  }]);

  return Search;
}(Component);

Search.propTypes = {
  /**
   * Render additional options in the autocompleter to allow free text entering depending on the type.
   */
  allowFreeTextSearch: PropTypes.bool,

  /**
   * Class name applied to parent div.
   */
  className: PropTypes.string,

  /**
   * Function called when selected results change, passed result list.
   */
  onChange: PropTypes.func,

  /**
   * The object type to be used in searching.
   */
  type: PropTypes.oneOf(['categories', 'countries', 'coupons', 'customers', 'downloadIps', 'emails', 'orders', 'products', 'taxes', 'usernames', 'variations']).isRequired,

  /**
   * A placeholder for the search input.
   */
  placeholder: PropTypes.string,

  /**
   * An array of objects describing selected values. If the label of the selected
   * value is omitted, the Tag of that value will not be rendered inside the
   * search box.
   */
  selected: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    label: PropTypes.string
  })),

  /**
   * Render tags inside input, otherwise render below input.
   */
  inlineTags: PropTypes.bool,

  /**
   * Render a 'Clear' button next to the input box to remove its contents.
   */
  showClearButton: PropTypes.bool,

  /**
   * Render results list positioned statically instead of absolutely.
   */
  staticResults: PropTypes.bool,

  /**
   * Whether the control is disabled or not.
   */
  disabled: PropTypes.bool
};
Search.defaultProps = {
  allowFreeTextSearch: false,
  onChange: noop,
  selected: [],
  inlineTags: false,
  showClearButton: false,
  staticResults: false,
  disabled: false
};
export default Search;
//# sourceMappingURL=index.js.map